var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Row from 'antd/lib/row';
import React, { useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import useMeasure from 'react-use/lib/useMeasure';
import { AntButton } from 'renderer/components';
import styled from 'styled-components';
export var SignaturePad = function (props) {
    var _a = props.showButton, showButton = _a === void 0 ? true : _a, buttonText = props.buttonText, onSubmit = props.onSubmit;
    var ref = React.useRef();
    var _b = React.useState(props.value), value = _b[0], setValue = _b[1];
    var _c = useMeasure(), wrapperRef = _c[0], _d = _c[1], x = _d.x, y = _d.y, width = _d.width, height = _d.height, top = _d.top, right = _d.right, bottom = _d.bottom, left = _d.left;
    var handleEnd = function (data) {
        if (ref && ref.current) {
            var value_1 = ref.current.toDataURL();
            props.onChange(value_1);
            setValue(value_1);
        }
    };
    useEffect(function () {
        if (!!(ref === null || ref === void 0 ? void 0 : ref.current) && !!props.value) {
            try {
                var img_1 = new Image();
                var canvas_1 = ref.current.getCanvas();
                var ctx_1 = canvas_1.getContext('2d');
                img_1.onload = function () {
                    // 캔버스 초기화
                    ctx_1.clearRect(0, 0, canvas_1.width, canvas_1.height);
                    // 이미지를 캔버스 크기에 맞게 비율 조정
                    var scale = Math.min(canvas_1.width / img_1.width, canvas_1.height / img_1.height);
                    var scaledWidth = img_1.width * scale;
                    var scaledHeight = img_1.height * scale;
                    // 이미지를 캔버스 중앙에 배치
                    var x = (canvas_1.width - scaledWidth) / 2;
                    var y = (canvas_1.height - scaledHeight) / 2;
                    ctx_1.drawImage(img_1, x, y, scaledWidth, scaledHeight);
                };
                img_1.src = props.value;
            }
            catch (error) {
                console.error(error);
            }
        }
    }, [props.value]);
    var handleClear = function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (value) {
            setValue(undefined);
            props.onChange(undefined);
            if (ref.current) {
                ref.current.clear();
            }
        }
    };
    return (React.createElement(SignaturePadWrapper, { className: "signature-pad-wrapper" },
        React.createElement(SizemeStyled, { className: "sizeme-styled", ref: wrapperRef, style: { pointerEvents: props.disabled ? 'none' : undefined } },
            React.createElement(SignatureCanvas, { ref: ref, canvasProps: { width: width, height: height }, onEnd: handleEnd })),
        React.createElement(Row, { justify: "end", style: { columnGap: 8 } },
            showButton && (React.createElement(AntButton, { children: buttonText || '재작성', onClick: handleClear, disabled: props.disabled || !value })),
            onSubmit && (React.createElement(AntButton, { type: "primary", children: "\uC11C\uBA85\uC644\uB8CC", onClick: onSubmit, disabled: props.disabledSubmit || !value })))));
};
export var SignaturePadWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 240px;\n  padding: 12px 12px 5px 12px;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--gray-7);\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  height: 240px;\n  padding: 12px 12px 5px 12px;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--gray-7);\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n"])));
export var SizemeStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-height: 176px;\n  flex: 1;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n"], ["\n  width: 100%;\n  max-height: 176px;\n  flex: 1;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n"])));
var templateObject_1, templateObject_2;
